"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _CodeEditor = _interopRequireDefault(require("@insided/shared/uikit/CodeEditor"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CustomCss = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CustomCss, _Component);

  var _super = _createSuper(CustomCss);

  function CustomCss() {
    var _this;

    (0, _classCallCheck2.default)(this, CustomCss);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      content: _this.props.content || '',
      defaultValue: _this.props.content || '',
      isError: false,
      isSaved: false,
      errorMessage: ''
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSubmit", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
        var errorMessage;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                _context.prev = 1;
                _context.next = 4;
                return _axios.default.post('/branding/updateCustomCss', {
                  data: _this.state.content
                });

              case 4:
                _this.setState({
                  isSaved: true
                });

                _context.next = 12;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](1);
                errorMessage = '';
                errorMessage = _context.t0.response.data.errors.customCss.reduce(function (accum, item) {
                  accum += '<br>' + item;
                  return accum;
                });

                _this.setState({
                  isError: true,
                  errorMessage: errorMessage
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 7]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChange", function (data) {
      _this.setState({
        content: data
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCloseNotification", function () {
      _this.setState({
        isError: false,
        isSaved: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOpenEmbeddables", function () {
      var embeddablesButton = document.querySelector('.insided-conversational-trigger-button');

      if (embeddablesButton) {
        embeddablesButton.click();
      }
    });
    return _this;
  }

  (0, _createClass2.default)(CustomCss, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          defaultValue = _this$state.defaultValue,
          isError = _this$state.isError,
          isSaved = _this$state.isSaved,
          errorMessage = _this$state.errorMessage;
      return (0, _preact.h)("div", {
        className: "customCss"
      }, (0, _preact.h)("div", {
        className: "customCss__note"
      }, (0, _preact.h)("p", {
        className: "customCss__note-text"
      }, (0, _preact.h)("span", {
        className: "customCss__note-text-bold"
      }, "Note:"), " We recommend inviting a professional web developer to work with Custom CSS. Insert code at your own risk, and proceed with extreme caution. If you want to test your code before publishing we strongly recommend you to use your staging environment first.", ' ', (0, _preact.h)("button", {
        className: "customCss__note-text-btn",
        type: "button",
        onClick: this.handleOpenEmbeddables
      }, "View Custom CSS examples"))), isError && (0, _preact.h)(_AlertComponent.default, {
        messageType: "error",
        message: errorMessage,
        renderHTML: true,
        onClose: this.handleCloseNotification
      }), isSaved && (0, _preact.h)(_AlertComponent.default, {
        messageType: "success",
        onClose: this.handleCloseNotification
      }), (0, _preact.h)("form", {
        className: "customCss__form",
        onSubmit: this.handleSubmit
      }, (0, _preact.h)(_CodeEditor.default, {
        defaultValue: defaultValue,
        onChange: this.handleChange
      }), (0, _preact.h)("button", {
        type: "submit",
        id: "js-submit-custom-css",
        className: "hide"
      })));
    }
  }]);
  return CustomCss;
}(_preact.Component);

exports.default = CustomCss;